import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-gray-100/80'
          : 'bg-white/10 backdrop-blur-sm border-b border-white/10'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">

          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className={`text-xl font-bold cursor-pointer tracking-tight whitespace-nowrap transition-all duration-300 ${
              scrolled
                ? 'bg-gradient-to-r from-teal-500 to-teal-700 bg-clip-text text-transparent'
                : 'text-white'
            }`}
            style={{ fontFamily: '"Pacifico", serif' }}
          >
            Noah
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            {['About', 'Skills', 'Projects'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                className={`text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap relative group ${
                  scrolled ? 'text-gray-600 hover:text-teal-600' : 'text-white/90 hover:text-white'
                }`}
              >
                {item}
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-teal-500 rounded-full transition-all duration-200 group-hover:w-full"></span>
              </button>
            ))}

            <button
              onClick={() => scrollToSection('contact')}
              className="ml-2 px-5 py-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm font-semibold rounded-full hover:from-teal-600 hover:to-teal-700 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-all cursor-pointer ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu-3'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 pb-4">
            <div className="flex flex-col gap-1 pt-3">
              {['About', 'Skills', 'Projects'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item.toLowerCase())}
                  className="px-4 py-2.5 text-sm text-gray-700 hover:text-teal-600 hover:bg-teal-50 rounded-lg text-left font-medium transition-all cursor-pointer"
                >
                  {item}
                </button>
              ))}
              <div className="px-4 pt-2">
                <button
                  onClick={() => scrollToSection('contact')}
                  className="w-full py-2.5 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap text-center"
                >
                  Contact
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
